<template>
  <div class="myaccount row">
    <div class="col-sm-12">
      <Alerts />
      <LoadingSpinner v-if="isLoading" />
      <b-tabs>
        <b-tab title="Account Information" active v-if="!tabHidden('account-info')">
          <b-form @submit.prevent="updateProfile(false)" @reset="onReset">
            <p class="font-weight-bold">Personal Information</p>

            <b-row>
              <b-col sm="5">
                <b-form-input class="mb-2" type="text" size="sm" v-model="form.company"
                  placeholder="Company Name (please fill if applicable)"></b-form-input>

                <b-form-input class="mb-2" type="text" size="sm" v-model="form.name" placeholder="Full Name">
                </b-form-input>

                <GoogleAutoComplete :g-class="['form-control', 'form-control-sm', 'mb-2']" v-model="form.address"
                  placeholder="Address" @change="onGoogleAddressChange"></GoogleAutoComplete>

                <b-form-input class="mb-2" type="text" size="sm" v-model="form.address2"
                  placeholder="Address 2 (FL, Apt, Suite, Unit)"></b-form-input>

                <b-form-input class="mb-2" type="text" size="sm" v-model="form.city" placeholder="City"></b-form-input>

                <b-row no-gutters>
                  <b-col sm="6">
                    <b-form-select class="mb-2" type="text" size="sm" v-model="form.state" placeholder="State"
                      :options="stateSelectOptions"></b-form-select>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input class="mb-2" type="text" size="sm" v-model="form.postal_code"
                      placeholder="Postal Code"></b-form-input>
                  </b-col>
                </b-row>

                <b-row no-gutters>
                  <b-col sm="6">
                    <b-form-input id="name" class="mb-2" type="text" size="sm" v-model="form.phone"
                      v-mask="'(###) ###-####'" placeholder="(XXX) XXX - XXXX"></b-form-input>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input class="mb-2" type="text" size="sm" v-model="form.ext" placeholder="Ext.">
                    </b-form-input>
                  </b-col>
                </b-row>

                <b-row no-gutters>
                  <b-col sm="auto" class="mr-1">
                    <b-btn @click="verifyAddress" size="sm" class="btn-light-blue-outline mr-2">
                      <img class="verifyImg" src="/images/icons/verify-address-blue.png">
                      Verify Address
                    </b-btn>
                  </b-col>
                  <b-col sm="auto">
                    <b-btn class="btn-blue" type="submit" size="sm">Save Changes</b-btn>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>

          <hr>

          <b-row>
            <b-col sm="4">
              <b-form @submit.prevent="updatePassword" @reset="onReset">
                <p class="font-weight-bold">Change Current Password</p>

                <b-form-input type="password" class="mb-2" size="sm" v-model="form2.current_password"
                  placeholder="Enter Current Password"></b-form-input>

                <b-form-input type="password" class="mb-2" size="sm" v-model="form2.new_password"
                  placeholder="Enter New Password"></b-form-input>

                <b-form-input id="new_password_confirmation" class="mb-2" type="password" size="sm"
                  v-model="form2.new_password_confirmation" placeholder="Confirm New Password"></b-form-input>

                <b-row>
                  <b-col sm="auto">
                    <b-button class="btn-blue" type="submit" size="sm">Save Changes</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
            <b-col sm="3"></b-col>

            <b-col sm="4">
              <b-form @submit.prevent="updateEmail" @reset="onReset">
                <p class="font-weight-bold">Change Login Email Address</p>

                <b-form-input type="password" class="mb-2" size="sm" v-model="form3.current_password"
                  placeholder="Enter Current Password"></b-form-input>

                <b-form-input type="email" class="mb-2" size="sm" v-model="form3.email" placeholder="New Email Address">
                </b-form-input>

                <b-form-input type="text" class="mb-2" size="sm" v-model="form3.email2"
                  placeholder="Confirm New Email Address"></b-form-input>

                <b-row>
                  <b-col sm="auto">
                    <b-button class="btn-blue" type="submit" size="sm">Save Changes</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>

          <hr>

          <p class="mb-2 font-weight-bold">Deactivate Grandshipper Account</p>
          <p>Contact us at <a href="mailto:support@grandshipper.com">support@grandshipper.com</a></p>
        </b-tab>
        <b-tab title="Shipment Settings" v-if="!tabHidden('advanced')">
          <p class="font-weight-bold">Active Mail Classes</p>
          <p>Select mail classes to include in the service dropdowns.</p>
          <b-form @submit.prevent="updateActiveMailClasses">
            <p class="font-weight-bold mb-1">Domestic Services</p>
            <b-checkbox-group v-model="active_mail_classes" class="mb-3 chckbox-grp" stacked multiple>
              <b-form-checkbox v-for="(service, i) in getActiveMailClassOptions()" :key="i" :value="service.value"
                :disabled="isDiscontinued(service.value)">
                <s v-if="isDiscontinued(service.value)">
                  {{ service.text }}
                </s>
                <span v-else>
                  {{ service.text }}
                </span>
                <span v-if="service.value == 'PM-RBA'">
                  <span class=" d-inline-block" tabindex="0">
                    <b-link>
                      <i id="pm-rba" class="ml-2 fa fa-exclamation-circle" style="font-size: 14px"></i>
                    </b-link>
                  </span>
                  <b-popover target="pm-rba">
                    <p class="text-left">
                    <ul class="pl-3 mb-0 text-left">
                      <li>
                        USPS retires the Regional Rate Boxes as of 1.22.2023 - <a
                          href="https://faq.usps.com/s/article/Regional-Rate-Boxes"
                          target="_blank">https://faq.usps.com/s/article/Regional-Rate-Boxes</a>
                      </li>
                    </ul>
                    </p>
                  </b-popover>
                </span>
                <span v-if="service.value == 'MEDIA-PKG'">
                  <span class="d-inline-block" tabindex="0">
                    <b-link>
                      <i id="media-pkg" class="ml-2 fa fa-exclamation-circle" style="font-size: 14px"></i>
                    </b-link>
                  </span>
                  <b-popover target="media-pkg">
                    <p class="text-left">
                      Here's what you can send:
                      <br />
                      <br />
                    <ul class="pl-3 mb-0 text-left">
                      <li>Books (at least 8 pages)</li>
                      <li>16-millimeter or narrower width films</li>
                      <li>Printed music and test materials</li>
                      <li>Video and sound recordings</li>
                      <li>Playscripts and manuscripts</li>
                      <li>Printed educational reference charts</li>
                      <li>Medical loose-leaf pages and binders</li>
                      <li>Computer-readable media</li>
                    </ul>
                    <br />
                    <em>NOTE: Video games, computer drives, and digital drives do not qualify for Media Mail
                      prices.</em>
                    </p>
                  </b-popover>
                </span>
                <span v-if="service.value == 'PM-IRRPKG'">
                  <span class="d-inline-block" tabindex="0">
                    <b-link>
                      <i id="pm-irrpkg" class="ml-2 fa fa-exclamation-circle" style="font-size: 14px"></i>
                    </b-link>
                  </span>
                  <b-popover target="pm-irrpkg">
                    <p class="text-left">
                      Examples of Irregular Packages
                    <ul class="pl-3 mb-0 text-left">
                      <li>Tubes/Cylindrical</li>
                      <li>Guitars</li>
                      <li>Tires</li>
                      <li>Fishing Pole</li>
                      <li>Golf Clubs</li>
                    </ul>
                    <br />
                    <em class="text-left">How to Measure and Enter Dimensions</em><br />
                    <ul class="pl-3 mb-0 text-left">
                      <li>
                        Girth = (2 x Height) + (2 x Width)
                        <br />
                        <a href="https://pe.usps.com/text/dmm100/tips-measure-packages.htm"
                          target="_blank">https://pe.usps.com/text/dmm100/tips-measure-packages.htm</a>
                      </li>
                      <li>
                        Length, Width, and Height
                        <br />
                        <a href="https://pe.usps.com/cpim/ftp/manuals/qsg300/Q201e.pdf"
                          target="_blank">https://pe.usps.com/cpim/ftp/manuals/qsg300/Q201e.pdf</a>
                      </li>
                    </ul>
                    </p>
                  </b-popover>
                </span>
                <span v-if="service.value == 'PRCLSEL-PKG'">
                  <span class="d-inline-block" tabindex="0">
                    <b-link>
                      <i id="prclsel-pkg" class="ml-2 fa fa-exclamation-circle" style="font-size: 14px"></i>
                    </b-link>
                  </span>
                  <b-popover target="prclsel-pkg">
                    <a href="https://faq.usps.com/s/article/USPS-Ground-Advantage"
                      target="_blank">https://faq.usps.com/s/article/USPS-Ground-Advantage</a>
                  </b-popover>
                </span>
              </b-form-checkbox>
            </b-checkbox-group>

            <hr>

            <p class="font-weight-bold mb-1">International Services</p>
            <b-checkbox-group v-model="active_mail_classes" :options="getActiveMailClassOptions('PH')"
              class="mb-3 chckbox-grp" stacked multiple></b-checkbox-group>

            <b-btn class="btn-blue" type="submit" size="sm">Save</b-btn>
          </b-form>

          <hr>

          <p class="font-weight-bold">Shipping Options</p>

          <p>The options below allows you to activate and deactivate your Shipping Options creating a customize look in
            the New Shipment page.</p>

          <b-checkbox-group v-model="selectedShippingOptions" :options="shippingSelectOptions" class="mb-3 chckbox-grp"
            stacked multiple></b-checkbox-group>

          <b-btn class="btn-blue" size="sm" @click="saveSelectedShippingOptions">Save</b-btn>

          <hr>

          <p class="font-weight-bold">Package Detail Default</p>
          <b-row>
            <b-col>
              <toggle-button :color="{ checked: '#36b520', unchecked: '#f29fa1' }"
                :switch-color="{ checked: '#0c820a', unchecked: '#820a0c' }"
                :value="user.default_package === 1 ? true : false" :width="65"
                :labels="{ checked: 'Active', unchecked: 'Inactive' }" @change="packageDetailToggle" />
              <span class="ml-2">
                If active, and an address has been entered, the fields below will be the default.
              </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-select size="sm" v-model="selectedService" :options="serviceOptions"
                      :class="['form-control', 'custom-dropdown', { 'is-invalid': !selectedService }]"
                      @change="onServiceClassChange">
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-select size="sm" :options="packageOptions"
                      :class="['form-control', 'custom-dropdown', { 'is-invalid': !selectedPackage }]"
                      :disabled="!selectedService" v-model="selectedPackage" @change="onPackageChange">
                      <template slot="first">
                        <option :value="''" disabled>Select Package Type</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <!-- MY PACKAGING -->
                    <b-select size="sm" :options="dimensionsPresetOptions" v-model="tmpMyPkg"
                      :disabled="!(dimensionsPresetOptions.length > 1)" class="form-control" name="customsContentType"
                      @change="onPackagingSelected">
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col sm="1">
                  <label class="p-1">
                    <b-img src="/images/icons/wgt-sm.png" width="25" v-b-tooltip.hover title="Weight" />
                  </label>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-form-input size="sm" type="number" placeholder="LB" :class="[{ 'is-invalid': noWeight && !noLB }]"
                      v-model="weight.lb" :disabled="noLB" @change="setWeight"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <b-form-input size="sm" type="number" placeholder="OZ" :class="[{ 'is-invalid': noWeight }]"
                      v-model="weight.oz" @change="setWeight" />
                  </b-form-group>
                </b-col>
                <b-col sm="1">
                  <label class="pull-right p-1">
                    <b-img src="/images/icons/dim-sm.png" width="25" v-b-tooltip.hover title="Dimensions" />
                  </label>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <b-form-input :disabled="isDimAllowed" size="sm" type="number"
                      :class="[{ 'is-invalid': !checkDimensions }]" placeholder="L" v-model="package.length" />
                    <!-- @change="onChangeDimensions()" -->
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <b-form-input :disabled="isDimAllowed" size="sm" type="number"
                      :class="[{ 'is-invalid': !checkDimensions }]" placeholder="W" v-model="package.width" />
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <b-form-input :disabled="isDimAllowed || selectedPackage == 'SOFTPACK'" size="sm" type="number"
                      :class="[{ 'is-invalid': !checkDimensions }]" placeholder="H" v-model="package.height" />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-col>
            <b-col sm="6">
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-form-select size="sm" v-model="selectedConfirm" :options="signatureOptions"
                      :disabled="!selectedPackage">
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-form-input size="sm" :disabled="!selectedPackage" v-model="declaredValue"
                      @keyup.native="(e) => { onKeyUpDeclaredValue(e, null) }" type="number" name="declared-value"
                      placeholder="Declared Value"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-form-select size="sm" v-model="selectedInsurance" :options="insuranceOptions"
                      :disabled="!selectedPackage || !declaredValue">
                      <template slot="first">
                        <option :value=null>None (Default Insurance)</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-col>
          </b-row>

          <b-btn class="btn-blue" type="submit" size="sm" :disabled="isPackageDetailInvalid"
            @click="saveDefaultPackage">Save</b-btn>

          <hr>

          <p class="font-weight-bold">My Custom Packaging</p>
          <v-client-table v-if="dimensions.data.length > 0" ref="dimensions_table" :columns="dimensions.columns"
            :data="dimensions.data" :options="dimensions.options">
            <div slot="is_default" slot-scope="props">
              <b-form-radio-group v-model="dimensions.default">
                <b-form-radio :disabled="user.default_package ? true : false" :value="props.row.id"></b-form-radio>
              </b-form-radio-group>
            </div>

            <template slot="child_row" slot-scope="props">
              <b-form @submit.prevent="(e) => {
                e.stopPropagation();
                onEditDimensionSubmit(props.row.id);
              }" @reset="onEditDimensionReset">
                <b-form-row>
                  <b-col>
                    <b-form-group>
                      <b-input placeholder="Name" type="text" size="sm"
                        v-model="dimensions.edit_form[props.row.id].name"></b-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <b-input placeholder="Length" type="number" size="sm" min="1"
                        v-model="dimensions.edit_form[props.row.id].length"></b-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <b-input placeholder="Width" type="number" size="sm" min="1"
                        v-model="dimensions.edit_form[props.row.id].width"></b-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <b-input placeholder="Height" type="number" size="sm" min="1"
                        v-model="dimensions.edit_form[props.row.id].height"></b-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-btn size="sm" type="submit">Submit</b-btn>
                  </b-col>
                </b-form-row>
              </b-form>
            </template>

            <div slot="actions" slot-scope="props">
              <button class="btn btn-primary btn-xs view" @click="editDimension(props.row.id)">Edit</button>

              <button class="btn btn-primary btn-xs" @click="deleteDimension(props.row.id)">Delete</button>
            </div>
          </v-client-table>

          <div class="mb-4">
            <b-form-checkbox v-model="dimensions.default" :value="null" @click.prevent="e => {
              dimensions.default = null;
            }">No default dimension</b-form-checkbox>
          </div>

          <p class="font-weight-bold">Create New Package Dimension</p>

          <b-row>
            <b-col cols="6">
              <b-form @submit.prevent="createDimension">
                <b-form-row>
                  <b-col>
                    <b-form-group>
                      <b-input placeholder="Name" type="text" size="sm" v-model="dimensions.create_form.name"
                        v-validate="'required'"></b-input>
                      <div class="invalid-feedback" v-if="errors.has('')">{{ errors.first('') }}</div>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-input-group class="default" prepend="Dimensions" append="in" size="sm">
                      <b-input placeholder="Length" type="number" min="1" size="sm"
                        v-model="dimensions.create_form.length"></b-input>
                      <b-input placeholder="Width" type="number" min="1" size="sm"
                        v-model="dimensions.create_form.width"></b-input>
                      <b-input placeholder="Height" type="number" min="1" size="sm"
                        v-model="dimensions.create_form.height"></b-input>
                    </b-input-group>
                  </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                  <b-col>
                    <b-btn class="btn-light-blue-outline" size="sm" type="submit">Create New Package</b-btn>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-col>
          </b-row>

          <hr>

          <p class="font-weight-bold">Marketplace Reference</p>

          <p>Activate any marketplaces that will appear in the New Shipment page. &nbsp;Generally used to manage and
            view shipments in the Shipped page.</p>

          <b-checkbox-group v-model="selectedMarketplaces" :options="marketplaceOptions" class="mb-3 chckbox-grp" stacked
            multiple></b-checkbox-group>

          <b-btn class="btn-blue" size="sm" @click="saveMarketPlaces">Save</b-btn>
        </b-tab>

        <b-tab title="Origin Addresses" v-if="!tabHidden('origins')">
          <p class="mb-2 font-weight-bold">Origin Addresses (Ship From Addresses)</p>

          <v-client-table ref="origins_table" :columns="origins.columns" :data="origins.data" :options="origins.options"
            class="originsTable">
            <template slot="is_default" slot-scope="props" class="col-1">
              <b-form-radio-group v-model="origins.default">
                <b-form-radio :value="props.row.id" size="sm"></b-form-radio>
              </b-form-radio-group>
            </template>

            <template slot="child_row" slot-scope="props">
              <b-form @submit.prevent="(e) => {
                e.stopPropagation();
                onEditOriginSubmit(props.row.id);
              }" @reset="onEditOriginReset">
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group label="First Name" label-for="first_name">
                      <b-form-input id="first_name" type="text" class="btn-xs"
                        v-model="origins.edit_form[props.row.id].first_name" placeholder="First Name"></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group label="Last Name" label-for="last_name">
                      <b-form-input id="last_name" type="text" size="sm"
                        v-model="origins.edit_form[props.row.id].last_name" placeholder="Last Name"></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group label="Company" label-for="company">
                      <b-form-input type="text" size="sm" v-model="origins.edit_form[props.row.id].company"
                        placeholder="Company"></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group label="Address" label-for="address">
                      <b-form-input id="address" type="text" size="sm" v-model="origins.edit_form[props.row.id].address"
                        maxlrngth="46" placeholder="Address"></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group label="City" label-for="city">
                      <b-form-input id="city" type="text" size="sm" v-model="origins.edit_form[props.row.id].city"
                        placeholder="City"></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group label="State/Province" label-for="state">
                      <b-form-select id="state" type="text" size="sm" v-model="origins.edit_form[props.row.id].state"
                        placeholder="State/Province" :options="stateSelectOptions"></b-form-select>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group label="Country" label-for="country">
                      <b-form-input value="US" size="sm" disabled></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group label="Postal Code" label-for="postal">
                      <zip-code-input id="postal" class="form-control form-control-sm" placeholder="Postal Code"
                        v-model="origins.edit_form[props.row.id].postal" :name="'postal' + props.row.id" @input="(val) => {
                          $forceUpdate();
                        }" />
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group label="Origin Postal Code (Post Office Postal Code where packages will be processed)"
                      label-for="postal_origin">
                      <zip-code-input id="postal_origin" class="form-control form-control-sm"
                        placeholder="Origin Postal Code" v-model="origins.edit_form[props.row.id].postal_origin"
                        :name="'postal_origin' + props.row.id" @input="(val) => {
                          $forceUpdate();
                        }" />
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group label="Phone Number" label-for="phone">
                      <b-form-input id="phone" type="tel" v-model="origins.edit_form[props.row.id].phone"
                        v-mask="'(###) ###-####'" placeholder="Phone Number"></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <b-button type="submit" size="sm">Submit</b-button>
              </b-form>
            </template>

            <div slot="actions" slot-scope="props">
              <button class="btn btn-primary btn-xs" @click="onShowOriginModal(props.row.id)">Edit</button>
              <!-- <button class="btn btn-primary btn-xs" @click="editOrigin(props.row.id)">Edit</button> -->
              <button class="btn btn-primary btn-xs" @click="deleteOrigin(props.row.id)">Delete</button>
            </div>
            <div slot="name" slot-scope="props">
              {{ props.row.first_name }} {{ props.row.last_name }}
            </div>
            <div slot="address" slot-scope="props">
              {{ props.row.address }}<br />
              {{ props.row.city }}, {{ props.row.state }}<br />
              {{ props.row.country }} <br />
            </div>
          </v-client-table>

          <b-row class="justify-content-between">
            <b-col sm="auto">
              <b-form-checkbox v-model="origins.default" :value="null" @click.prevent="e => {
                origins.default = null;
              }">No Default Address (User will manually pick from drop down list in New Shipment page)
              </b-form-checkbox>
            </b-col>
            <b-col sm="auto">
              <b-btn class="btn-light-blue-outline" @click="onShowOriginModal(null)">
                Add New Origin Address
              </b-btn>
            </b-col>
          </b-row>

          <!-- <div class="mb-4">
            <b-form-checkbox
              v-model="origins.default"
              :value="null"
              @click.prevent="e => {
                  origins.default = null;
                }"
            >No default address</b-form-checkbox>
          </div>

          <h3 class="font100">Create New Origin Address</h3>

          <b-form @submit.prevent="createOrigin" data-vv-scope="create-origin">
            <div class="row">
              <div class="col-sm-6">
                <b-form-group label="First Name" label-for="first_name">
                  <b-form-input
                    id="first_name"
                    name="first_name"
                    type="text"
                    size="sm"
                    v-model="origins.create_form.first_name"
                    placeholder="First Name"
                  ></b-form-input>
                </b-form-group>/icons/qz.png" style="width: 1rem" alt="qz" />&nbsp;) must be downloaded for settings to apply
              </p>
              <p>
                <a target="_blank" href="https://qz.io/download/">Click he
              </div>

              <div class="col-sm-6">
                <b-form-group label="Last Name" label-for="last_name">
                  <b-form-input
                    id="last_name"
                    name="last_name"
                    type="text"
                    size="sm"
                    v-model="origins.create_form.last_name"
                    placeholder="Last Name"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <b-form-group label="Company" label-for="company">
                  <b-form-input
                    id="company"
                    name="company"
                    type="text"
                    size="sm"
                    v-model="origins.create_form.company"
                    placeholder="Company"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group label="Address" label-for="address">
                  <GoogleAutoCompleteS
                    :g-class="['form-control', 'form-control-sm']"
                    v-model="origins.create_form.address"
                    placeholder="Address"
                    @change="onGoogleAddressChange"
                  ></GoogleAutoCompleteS>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <b-form-group label="City" label-for="city">
                  <b-form-input
                    id="city"
                    name="city"
                    type="text"
                    size="sm"
                    v-model="origins.create_form.city"
                    placeholder="City"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group label="State/Province" label-for="state">
                  <b-form-select
                    id="state"
                    type="text"
                    size="sm"
                    v-model="origins.create_form.state"
                    placeholder="State/Province"
                    :options="stateSelectOptions"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <b-form-group label="Country" label-for="country">
                  <b-form-input value="US" size="sm" disabled></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group label="Postal Code" label-for="postal">
                  <zip-code-input
                    id="postal"
                    type="text"
                    size="sm"
                    class="form-control form-control-sm"
                    v-model="origins.create_form.postal"
                    placeholder="Postal Code"
                  ></zip-code-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <b-form-group label="Origin Postal Code (Post Office Postal Code where packages will be processed)" label-for="postal-origin">
                  <zip-code-input
                    id="postal-origin"
                    type="text"
                    class="form-control form-control-sm"
                    v-model="origins.create_form.postal_origin"
                    placeholder="Origin Postal Code"
                  ></zip-code-input>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group label="Phone Number" label-for="phone">
                  <b-form-input
                    name="phone"
                    type="tel"
                    size="sm"
                    v-model="origins.create_form.phone"
                    v-mask="'(###) ###-####'"
                    placeholder="Phone Number"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <b-button type="submit" size="sm">Submit</b-button>
          </b-form> -->
        </b-tab>

        <b-tab title="Postage Settings" :active="$route.params.section === 'postage'" v-if="!tabHidden('postage')">
          <p class="mb-2 font-weight-bold">Available Postage: {{ this.balance }} USD</p>
          <p class="mb-2">Pitney Bowes Merchant Account Number: {{ this.user.shipper_id }}</p>
          <p class="mb-5">Would you like to update your payment method?&nbsp;&nbsp;Log into your Pitney Bowes Merchant
            Portal by <a
              href="https://login2.pitneybowes.com/login?productId=shipperapplication&flow=v2&TargetResource=https:%2F%2Fpitneybowes.okta.com%2Foauth2%2Faus13gs0hnB5KIbVz1t7%2Fv1%2Fauthorize%3Fclient_id%3D7KBCxIR3F381AzL1TTLs%26scope%3Dopenid%26response_type%3Dtoken%20id_token%26response_mode%3Dform_post%26nonce%3D1111%26state%3D%2Fdashboard%26redirect_uri%3Dhttps:%2F%2Fwww.pbshippingmerchant.pitneybowes.com%2Fwelcome"
              target="_blank">clicking here</a>.</p>

          <p>One Time Postage Purchase (enter amount below).</p>
          <postage-refill></postage-refill>

          <hr>

          <p class="font-weight-bold">Auto Refill Settings</p>
          <postage-refill-settings></postage-refill-settings>

          <hr>

          <p class="mb-2 font-weight-bold">Postage Refill History (Last 10 Transactions)</p>
          <p>Postage refills may take up to two hours to appear in the table below. &nbsp;To view more refill history,
            please log into your Pitney Bowes Merchant Portal under transactions.</p>
          <b-row>
            <b-col sm="4">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-center font-weight-bold">Postage Refill Date</th>
                    <th class="text-center font-weight-bold">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="t in transactions" :key="t.id">
                    <td class="text-center">{{ t.date | utcDate('dddd, MMMM Do, YYYY h:mm:ss a z') }}</td>
                    <!-- this will use moment.tz.guess() -->
                    <!-- <td class="text-center">{{ t.date | readableDate('dddd, MMMM Do, YYYY h:mm:ss a') }}</td> -->
                    <td class="text-center">{{ numeral(t.amount).format('$0,0.00') }}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <hr>

          <p class="mb-2 font-weight-bold">Unlink Pitney Bowes Account</p>
          <p>Disconnect my Pitney Bowes Merchant Account with Grandshipper by <a href="javascript:void(0)"
              @click="unLinkPB">clicking here</a>.</p>

          <!-- <b-row class="mt-5 mb-1">
            <b-col>
              <p
                class="d-inline-block align-middle mb-0 font-weight-bold"
              >Log into your Pitney Bowes Merchant Portal →</p>
              <a href="https://www.pbshippingmerchant.pitneybowes.com/" target="_blank" class="ml-2">
                <img
                  src="/images/pb-logo-sm.png"
                  title="Click here to log into your Pitney Bowes Merchant Portal"
                >
              </a>
            </b-col>
            <b-col>
              <div class="pull-right">
                <b-btn
                  variant="danger"
                  @click="unLinkPB"
                >Unlink PB Account</b-btn>
              </div>
            </b-col>
          </b-row> -->

          <!--<img src="/images/pb-portal-screenshot.png" class="w-100">-->
        </b-tab>
        <b-tab :active="$route.params.section === 'print-settings'" v-if="!tabHidden('print-settings')">
          <template slot="title">
            Label Settings & Hardware
            <!-- <img src="/images/new.png" style="width: 20px; margin: -20px 0 0 -5px;" /> -->
          </template>
          <b-row>
            <b-col>
              <p class="font-weight-bold">
                Printer Driver (QZ Tray&nbsp;&nbsp;
                <b-img src="/images/icons/qz.png" style="width: 1rem" alt="qz" />&nbsp;) must be downloaded for settings
                to apply
              </p>
              <p>
                <a target="_blank" href="https://qz.io/download/">Click here to Download Printer Driver</a>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="4" md="6" fluid="sm">
              <p>Thermal Printer (Rollo, Zebra, DYMO, etc.)</p>
              <b-img src="/images/print_preview/thermal.png"
                style="max-width: 10rem; height: 10rem; margin-bottom: 1rem;"></b-img>
              <b-form-group label="Label Layout">
                <b-form-radio v-model="shipping_label_formats.selected" size="sm" inline name="paper_type"
                  @change="updatePrintSettings" value="1">4x6 Label Roll</b-form-radio>
                <b-form-radio v-model="shipping_label_formats.selected" size="sm" inline name="paper_type"
                  @change="updatePrintSettings" value="2">4x6 plus 2" doc tab Label Roll</b-form-radio>
              </b-form-group>

              <div style="padding-left: 2rem;">
                <b-img v-show="shipping_label_formats.preview == 1" style="width: 8rem;"
                  src="/images/print_preview/1.png" />
                <span v-show="shipping_label_formats.preview == 2">
                  <b-row>
                    <b-col md="5">
                      <b-img style="width: 8rem;" src="/images/print_preview/2.png" />
                    </b-col>
                    <b-col md="7">
                      <strong>2” Doc Tab will include</strong>
                      <ul style="padding-left: 15px;">
                        <li>Ship From Company &amp; Name</li>
                        <li>Ship To Company &amp; Name</li>
                        <li>Tracking #</li>
                        <li>Printed Date</li>
                        <li>Order #</li>
                        <li>Ref ID</li>
                        <!-- <li>Description</li> -->
                        <li>Custom Field 1</li>
                        <!-- <li>Custom Field 2</li> -->
                        <!-- SOON -->
                        <li>Shipping Rate</li>
                      </ul>
                    </b-col>
                  </b-row>
                </span>
              </div>
            </b-col>

            <b-col xl="4" md="6" fluid="sm">
              <p>Laser/Inkjet (HP, Canon, Epson, etc.)</p>
              <b-img src="/images/print_preview/laser.png" style="max-width: 10rem; height: 10rem; margin-bottom: 1rem; ">
              </b-img>
              <b-form-group label="Label Layout">
                <!-- <b-form-radio v-model="shipping_label_formats.selected" size="sm" inline name="paper_type" @change="updatePrintSettings" value="3">8.5x11 Paper Portrait</b-form-radio> -->
                <b-form-radio v-model="shipping_label_formats.selected" size="sm" inline name="paper_type"
                  @change="updatePrintSettings" value="4">8.5x11 Paper Landscape</b-form-radio>
              </b-form-group>

              <div style="padding-left: 2rem;">
                <b-img v-show="shipping_label_formats.preview == 3" style="width: 8rem;"
                  src="/images/print_preview/3.png" />
                <b-img v-show="shipping_label_formats.preview == 4" style="width: 8rem;"
                  src="/images/print_preview/4.png" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button size="sm" @click="onClickPrintTest" :disabled="!allowTestPrint">Print Test Label</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <hr />
            </b-col>
            <b-col sm="12">
              <p class="font-weight-bold">Need a Thermal Printer, Scale, or Thermal Labels?</p>
              <p>Our preferred thermal label printer and scale are by Rollo. &nbsp;They offer a wireless or wired
                thermal printer, scale, and thermal labels.</p>
              <p><span class="font-weight-bold">Please use this special link for purchase:</span> <a
                  href="https://www.rollo.com/?ref=grandshipper"
                  target="_blank">https://www.rollo.com/?ref=grandshipper</a></p>
              <p>Rollo Printer Setup Guide: <a href="https://www.rollo.com/setup/"
                  target="_blank">https://www.rollo.com/setup/</a></p>
              <p>Rollo Support and How-To’s: <a href="https://support.rolloprinter.com/support/home"
                  target="_blank">https://support.rolloprinter.com/support/home</a></p>
              <p>Rollo Create a Support Ticket: <a href="https://support.rolloprinter.com/support/tickets/new"
                  target="_blank">https://support.rolloprinter.com/support/tickets/new</a></p>

              <b-img width="170" class="mr-4" src="/images/printer/1.png" />
              <b-img width="170" class="mr-4" src="/images/printer/2.png" />
              <b-img width="130" class="mr-4" src="/images/printer/3.png" />
              <b-img width="150" src="/images/printer/4.png" />
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="Integrations" :active="!!showIntegration || $route.params.section === 'integrations'"
          @click="changeTab('integrations')" v-if="!tabHidden('integrations')">
          <p class="font-weight-bold">Marketplace and Integrations</p>

          <p>Please choose which ecommerce marketplace you would like GrandShipper to connect with. &nbsp;All
            connections below has the ability retrieve all your ready to ship orders into the E-Commerce Store
            page. &nbsp;Once you generate a label through GrandShipper, it will automatically post back the tracking
            information and mark the order shipped/fulfilled.</p>

          <div class="row mb-3">
            {{ /* component declaration in main */ }}
            <component :is="marketplace.component" v-for="marketplace in marketplaces" v-bind:data="marketplace"
              v-bind:key="marketplace.code" :marketplace="marketplace.name" :code="marketplace.code"
              :logo="marketplace.logo"></component>
          </div>

          <hr>
          <p class="font-weight-bold">Existing Integrations</p>

          <b-card bg-variant="white">
            <table class="table table-bordered table-striped" id="integration-table">
              <thead>
                <tr style="text-align: center;">
                  <th style="width: 15rem;">Actions</th>
                  <th>Marketplace</th>
                  <th>Name</th>
                  <th>Nickname</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody v-if="integrations.length">
                <tr v-for="integration in integrations" :key="integration.name">
                  <td>
                    <b-btn variant="primary" size="sm" v-b-modal.modal-sm @click="editNickname(integration)">
                      Edit
                    </b-btn>
                    <b-btn variant="primary" size="sm" id="delete-btn" @click="deleteIntegration(integration.id)">
                      Delete
                    </b-btn>
                  </td>
                  <td>
                    <!-- <b-img :src="`/images/integrations/${integration.marketplace.code}/table-icon.png`" ></b-img> -->
                    <b-img :src="integration.marketplace.logo" style="height: 5rem"></b-img>
                  </td>
                  <td>{{ integration.name }}</td>
                  <td>{{ integration.nickname || 'N/A' }}</td>
                  <td>
                    <toggle-button :color="{ checked: '#36b520', unchecked: '#f29fa1' }"
                      :switch-color="{ checked: '#0c820a', unchecked: '#820a0c' }"
                      :value="integration.active ? true : false" :width="65" @change="disableIntegration(integration)"
                      :labels="{ checked: 'Active', unchecked: 'Inactive' }" />
                  </td>
                </tr>
                <tr v-if="!integrations.length">
                  <td colspan="5" class="text-center">No Integrations found</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-tab>

        <b-tab title="Subscription Options" :active="$route.params.section === 'subscription'"
          @click="changeTab('subscription')" v-if="!tabHidden('subscription')">
          <!-- @click="tab = 'subscription'" -->
          <div v-if="tab == 'subscription'">
            <!--  -->
            <p class="font-weight-bold">Subscription Options - Grand Plans</p>

            <b-row class="justify-content-center">
              <b-col sm="auto">
                <table class="subscription-table" cellspacing="0">
                  <thead>
                    <tr>
                      <th class="plan">
                        <h2>PLANS</h2>
                      </th>
                      <th class="starter">
                        <h2>PRO</h2>
                      </th>
                      <th class="supreme">
                        <h2>ENTERPRISE</h2>
                      </th>
                      <th class="supreme border-left border-white">
                        <div class="best">
                          <span>Best Value</span>
                        </div>
                        <h2>ENTERPRISE</h2>
                      </th>
                    </tr>
                    <tr class="desc">
                      <td class="plan">
                        <h6>FEATURES</h6>
                      </td>
                      <td class="starter">
                        <h6>FOR INDIVIDUALS OR <br>
                          SMALL BUSINESSES</h6>
                      </td>
                      <td class="supreme">
                        <h6>
                          45-DAY FREE TRIAL <br>
                          SIGN UP TODAY
                        </h6>
                      </td>
                      <td class="supreme border-left border-white">
                        <h6>
                          ANNUAL PLAN <br>
                          SAVE 33%
                        </h6>
                      </td>
                    </tr>
                    <tr class="desc-2">
                      <td>
                        <h3>Compare Plans</h3>
                      </td>
                      <td>
                        <h3 class="mb-0">FREE</h3>
                        <h6>Monthly</h6>
                      </td>
                      <td>
                        <h3 class="d-flex justify-content-center mb-0">
                          <span class="sup">$</span> 15
                        </h3>
                        <h6>Monthly</h6>
                      </td>
                      <td>
                        <h3 class="d-flex justify-content-center mb-0">
                          <span class="sup">$</span> 120
                        </h3>
                        <h6>Annually</h6>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in subscription_items" :key="index">
                      <td v-for="(i, k) in item" :key="k">
                        <span v-if="Number.isInteger(i)">

                          <i v-if="i == 2" class="fa fa-2x fa-thumbs-up" style="color: rgb(98, 189, 24);"></i>
                          <i v-else-if="i" class="fa fa-2x fa-check" style="color: rgb(98, 189, 24);"></i>
                          <i v-else class="fa fa-2x fa-times" style="color: rgb(239, 69, 69);"></i>
                        </span>
                        <span v-else v-html="i"></span>
                      </td>
                    </tr>
                    <tr class="default">
                      <td></td>
                      <td>
                        <b-btn v-if="subscriptionPlan != ''" @click="unSub" class="rounded-pill btn-dark">
                          Sign up
                        </b-btn>
                        <b-btn v-else-if="user.subscribed && !subscription.data.ends_at"
                          :disabled="subscription.data.ends_at" @click="unsubscribe" class="rounded-pill btn-dark">
                          Sign up
                        </b-btn>
                        <div v-else class="btn rounded-pill btn-green">
                          Selected
                        </div>
                      </td>
                      <td>
                        <div v-if="subscriptionPlan == 'monthly'" class="btn rounded-pill btn-green">
                          Selected
                        </div>
                        <b-btn v-else-if="!user.subscribed" class="rounded-pill btn-dark"
                          @click="chooseSubPlan('monthly')">
                          Sign up
                        </b-btn>
                        <b-btn v-else-if="user.subscribed && annually || subscription.data.ends_at"
                          :disabled="subscription.data.ends_at" class="rounded-pill btn-dark" @click="toggleSubscription">
                          Sign up
                        </b-btn>
                        <div v-else-if="user.subscribed && !annually" class="btn rounded-pill btn-green">
                          Selected
                        </div>
                      </td>
                      <td>
                        <div v-if="subscriptionPlan == 'annually'" class="btn ounded-pill btn-green">
                          Selected
                        </div>
                        <b-btn v-else-if="!user.subscribed" class="rounded-pill btn-dark"
                          @click="chooseSubPlan('annually')">
                          Sign up
                        </b-btn>
                        <b-btn v-else-if="user.subscribed && !annually || subscription.data.ends_at"
                          :disabled="subscription.data.ends_at" class="rounded-pill btn-dark" @click="toggleSubscription">
                          Sign up
                        </b-btn>
                        <div v-else-if="user.subscribed && annually" class="btn rounded-pill btn-green">
                          Selected
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <div class="mb-4" v-if="!user.has_shopify">
              <b-row class="my-3">
                <b-col sm="12" v-if="subscription.subscribed">
                  <p class="font-weight-bold">Payment Information</p>

                  <b-row>
                    <b-col sm="6">
                      <b-row>
                        <b-col sm="4">Sign Up Date:</b-col>
                        <b-col sm="8">
                          {{ subscription.data.created_at | readableDate('LLL') }}
                          <span v-if="subscription.data.ends_at">(cancelled)</span>
                          <span v-else>(auto renew)</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">Amount:</b-col>
                        <b-col sm="8">
                          {{ numeral(user.plan_price).format('$0,0.00') }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">Credit Card Brand:</b-col>
                        <b-col sm="8">{{ user.card_brand }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">Credit Card Last Four:</b-col>
                        <b-col sm="8">{{ user.card_last_four }}</b-col>
                      </b-row>
                      <b-row v-if="subscription.data.trial_ends_at">
                        <b-col sm="4">Trial Ends At:</b-col>
                        <b-col sm="8">{{ subscription.data.trial_ends_at | readableDate('LLL') }}</b-col>
                      </b-row>
                      <b-row v-if="subscription.data.ends_at">
                        <b-col sm="4">Ends At:</b-col>
                        <b-col sm="8">{{ subscription.data.ends_at | readableDate('LLL') }}</b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col sm="12" v-if="!subscription.subscribed && showSubscriptionCard">
                  <p>Payment information</p>
                  <b-row>
                    <b-col sm="6">
                      <Card ref="subscription_card" class="stripe-card" :stripe="stripeKey" :options="stripeOptions"
                        @change="subscription.stripeFormComplete = $event.complete" />
                      <b-input class="mt-2" v-model="subscription.coupon" placeholder="Coupon code"></b-input>
                      <b-btn class="btn-green mt-3" @click="pay" size="sm" :disabled="!subscription.stripeFormComplete">
                        Pay with Credit Card</b-btn>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" v-else-if="subscription.data.ends_at"></b-col>
                <b-col sm="12" v-else-if="subscription.subscribed" class="mt-3">
                  <b-row>
                    <b-col sm="6">
                      <Card ref="subscription_card" class="stripe-card" :stripe="stripeKey" :options="stripeOptions"
                        @change="subscription.stripeFormComplete = $event.complete" />
                      <b-btn class="btn-green mt-3" @click="updateCard" size="sm"
                        :disabled="!subscription.stripeFormComplete">Update Credit Card</b-btn>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col sm="12" v-if="subscription.subscribed">
                  <hr>
                  <p class="font-weight-bold">Cancel My Subscription</p>
                  <p>Your monthly or yearly subscription will discontinue upon cancelation</p>
                  <b-btn class="btn-dark" :disabled="subscription.data.ends_at" @click="unsubscribe" size="sm">Cancel
                    Subscription</b-btn>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
        <b-tab :active="$route.params.section === 'shipsurance'" @click="changeTab('shipsurance')"
          v-if="!tabHidden('shipsurance')">
          <template slot="title">
            Shipsurance
            <!-- <img src="/images/new.png" style="width: 20px; margin: -20px 0 0 -5px;" /> -->
          </template>
          <div v-if="tab == 'shipsurance'">
            <img src="/images/shipsurance-assurant-lockup-logo.png" width="350" class="mb-2" />

            <p class="mb-3">
              We partnered up with Shipsurance, a leading provider for insuring packages.&nbsp;&nbsp;You must prefund
              your Shipsurance Bank to purchase
              coverage.&nbsp;&nbsp;Once you decide to ensure a package, the amount will be deducted once label is
              processed.&nbsp;&nbsp;We currently cover only
              outbound packages and not Scan-Based Returns
            </p>

            <p class="mb-0">Insurance Rate (Up to $5,000 per package)</p>
            <ul>
              <li>
                <p class="mb-0">Domestic rate = $.75 cents per $100 value</p>
              </li>
              <li>
                <p class="mb-0">International rate = $1.35 cents per $100 value</p>
              </li>
            </ul>

            <b-form-checkbox :disabled="user.shipsurance_terms ? true : false" v-model="user.shipsurance_terms"
              :checked="user.shipsurance_terms" :value="1" :unchecked-value="0" @change="updateUserShipsurance"
              class="mb-3">
              <div class="font-weight-bold text-dark" style="margin-top: 3px;">
                I acknowledge and agree to Shipsurance <a href="https://www.shipsurance.com/grandshipper/terms"
                  target="_blank">Terms and Conditions</a>
                <span v-if="user.shipsurance_accepted_date"> - {{
                  user.shipsurance_accepted_date | readableDate
                }}</span>
              </div>
            </b-form-checkbox>

            <p class="mb-1 font-weight-bold">
              Pay special attention to the following coverage exclusions and conditions within the <a
                href="https://www.shipsurance.com/grandshipper/terms" target="_blank">Terms and Conditions</a>:
            </p>

            <ul>
              <li>Not all commodities and destinations are covered.&nbsp;&nbsp;Make sure the item(s) that you are
                shipping (Exclusion A) and the destination (Exclusion B) are not excluded from coverage.</li>
              <li>Items must not be shipped in the original manufacturers packaging or any packaging that alludes to the
                contents.&nbsp;&nbsp;(Exclusion E)</li>
              <li>All packaging material and damaged goods must be kept in the original form as
                received.&nbsp;&nbsp;Packaging and damaged goods should not be disposed of, released to the shipping
                carrier, or returned to the seller before a claim is completed.&nbsp;&nbsp;Failure to comply can result
                in the denial of the claim.&nbsp;&nbsp;(Condition B, 1)</li>
              <li>During the claims process, a claim statement/affidavit signed by the recipient (or intended recipient)
                will be required.&nbsp;&nbsp;This is a form document provided by Shipsurance that allows the recipient
                (or intended recipient) to indicate loss or damage.&nbsp;&nbsp;(Condition B, 3, d)</li>
              <li>Jewelry (includes necklaces, earrings, watches, rings, bracelets, broaches, etc.) with a value of
                $500.00 or more must be sent with the direct or adult Signature Confirmation Service provided by the
                Carrier (must be signed for at delivery).&nbsp;&nbsp;(Condition E)</li>
            </ul>

            <p class="mb-3 font-weight-bold">Shipsurance Available Balance: ${{ user.shipsurance_balance || '0' }}</p>

            <p class="mb-3">Automation Rule</p>

            <p class="mb-3">
              <toggle-button class="mt-1 mr-2" :disabled="!user.shipsurance_terms"
                :color="{ checked: '#36b520', unchecked: '#f29fa1' }"
                :switch-color="{ checked: '#0c820a', unchecked: '#820a0c' }"
                :value="user.enable_shipsurance === 1 ? true : false" :sync="true" :width="65" @change="shipsuranceToggle"
                :labels="{ checked: 'Active', unchecked: 'Inactive' }" />
              If there is a value more than $1 in the “Declared Value” field, automatically insure with Shipsurance
            </p>

            <div v-if="!user.card_brand && !user.shipsurance_card_brand" class="mb-4">
              <p class="mb-3">Please enter credit card to fund Shipsurance Bank</p>
              <b-form-row>
                <b-col sm="6">
                  <Card ref="shipsurance_card" class="stripe-card" :stripe="stripeKey" :options="stripeOptions"
                    @change="shipsurance.stripeFormComplete = $event.complete" />
                </b-col>
                <b-col sm="2" class="align-self-center">
                  <b-btn variant="primary" :disabled="!shipsurance.stripeFormComplete || !user.shipsurance_terms"
                    @click="updateShipsuranceCard">Enter</b-btn>
                </b-col>
              </b-form-row>
            </div>
            <div v-else class="mb-3">
              <b-form-row class="mb-3">
                <b-col sm="auto" style="margin-top: 6px;">
                  <span>Please enter an amount</span>
                </b-col>
                <b-col sm="2">
                  <!-- <b-form-input
                    :disabled="!user.shipsurance_terms"
                    v-model="shipsurance.amount"
                    size="sm"
                    style="height: 28px;"
                  ></b-form-input> -->
                  <money v-model="shipsurance.amount" class="form-control shipsurance-input" v-bind="{ precision: 0 }"
                    :disabled="!user.shipsurance_terms"></money>
                </b-col>
                <b-col sm="5" class="align-self-center">
                  <b-btn size="sm" variant="primary"
                    :disabled="!shipsurance.amount || !user.shipsurance_terms || shipsuranceLoading"
                    @click="payShipsurance">
                    <span v-if="shipsuranceLoading">
                      Purchasing
                      <b-spinner small></b-spinner>
                    </span>
                    <span v-else>
                      Process one-time payment
                    </span>
                  </b-btn>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col sm="4">
                  <p>Credit Card on file</p>
                  <table class="table">
                    <thead>
                      <tr>
                        <th>CC Brand</th>
                        <th>CC Last Four</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ user.shipsurance_card_brand || user.card_brand }}</td>
                        <td>{{ user.shipsurance_card_last_four || user.card_last_four }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col sm="6">
                  <Card ref="shipsurance_card" class="stripe-card" :stripe="stripeKey" :options="stripeOptions"
                    @change="shipsurance.stripeFormComplete = $event.complete" />
                </b-col>
                <b-col sm="2" class="align-self-center">
                  <b-btn variant="primary" :disabled="!shipsurance.stripeFormComplete" @click="updateShipsuranceCard">
                    Update Card</b-btn>
                </b-col>
              </b-form-row>
            </div>

            <hr>

            <h6 class="font-weight-bold">Common Coverage Questions</h6>
            <p class="mb-0 font-weight-bold">WHAT TYPE OF ITEMS CANNOT BE INSURED?</p>
            <p class="mb-3 text-danger">
              Accounts, bills, currency, cash in transit, evidence of debt, checks, money orders, cash on delivery (COD)
              payments, coins (collectible coins are not excluded), securities and other negotiable papers, tickets,
              deeds, notes, gift cards, manuscripts, documents, neon items, hazardous material (per UPS Hazardous
              Materials List), televisions, monitors, screens, perishable cargo or similar property, eggs, any stone or
              ceramic slabs, automobiles, motorcycles, live animals, flowers, plants, seeds, cigarettes/cigars, cotton,
              tobacco, windows, plate glass, stained glass, float glass, laptop computers (including tablets computers,
              iPads, and similar electronics), and mobile telephones (including cell phones, smart phones, and similar).
              <br><br>
              Additionally, collectible coins, comic books, sports cards and similar that are being shipped to be graded
              and have their value established are excluded.&nbsp;&nbsp;Collectible coins, comic books, sports cards,
              and similar are not excluded if they have already been graded and have their value established or if they
              were sold under a paid, commercial invoice or have a recent appraisal.
            </p>

            <p class="mb-0 font-weight-bold">WHAT COUNTRIES ARE EXCLUDED FROM COVERAGE?</p>
            <p class="mb-3 text-danger">Shipments sent to Afghanistan, Angola, Bolivia, Brazil, Burma, Congo, Cuba,
              Iran, Iraq, Ivory Coast (Cote d'Ivoire), Liberia, Nigeria, North Korea, Paraguay, Sierra Leone, Somalia,
              Sudan, Syria, Venezuela, and any location that would be in violation of any U.S.&nbsp;&nbsp;economic or
              trade sanctions including OFAC Restricted Countries.&nbsp;&nbsp;For shipments to Russian and other
              Commonwealth of Independent States countries (includes Armenia, Azerbaijan, Belarus, Georgia, Kazakhstan,
              Kyrgyzstan, Moldova, Russia, Russian Federation, Tajikistan, Turkmenistan, Ukraine, and Uzbekistan)
              coverage ceases upon touchdown of the aircraft at the airport of destination or upon discharge from the
              overseas vessel at the destination discharge port.</p>

            <p class="mb-0 font-weight-bold">IS BRANDED PACKAGING OR MANUFACTURER PACKAGING COVERED?</p>
            <p class="mb-3 text-danger">No.&nbsp;&nbsp;This program does not cover items shipped in the original
              manufacturers packaging or any packaging that alludes to the contents.&nbsp;&nbsp;This includes branded
              shipping boxes or branded tape.</p>

            <p class="mb-0 font-weight-bold">ARE THERE ANY REQUIREMENTS TO COVER JEWELRY?</p>
            <p class="mb-3 text-danger">Yes.&nbsp;&nbsp;Jewelry (includes necklaces, earrings, watches, rings,
              bracelets, broaches, etc) with a value of $500.00 or more must be sent with the Signature Confirmation
              service (package must be signed for at delivery) provided by the Carrier.&nbsp;&nbsp;This is required for
              Domestic and International shipments.&nbsp;p;(Conditions E)</p>

            <p class="mb-0 font-weight-bold">ARE STOLEN PACKAGES COVERED?</p>
            <p class="mb-3 text-danger">If a Package is stolen after delivery, there is no coverage.&nbsp;&nbsp;This
              certificate covers Packages from all risks of physical loss or damage from an external cause (subject to
              above listed exclusions) while in transit</p>

            <p class="mb-0 font-weight-bold">HOW DO I FILE A CLAIM?</p>
            <p class="mb-3">Claims are filed <a target="_blank"
                href="https://www.dsiins.com/extclaims/?cid=grandshipper">here</a>.</p>

            <p class="mb-3">During the claims process, a claim statement/affidavit signed by the recipient (or intended
              recipient) will be required.&nbsp;&nbsp;This is a form document provided by Shipsurance that allows the
              recipient (or intended recipient) to indicate loss or damage.&nbsp;p;(Condition B, 3)</p>

            <p class="mb-0 font-weight-bold">HOW DO I CHECK THE STATUS OF MY CLAIMS?</p>
            <p class="mb-3">You can check the status of an existing claim <a target="_blank"
                href="https://www.dsiins.com/claimstatus/?cid=grandshipper">here</a>.</p>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal ref="profileModal" no-close-on-backdrop no-close-on-esc hide-header-close :hide-header="true"
      :hide-footer="true">
      <template v-slot:modal-title>
        <strong class="font100">
          Personal Information
        </strong>
        <button @click="hideProfileModal" type="button" aria-label="Close" class="close">×</button>
      </template>

      <b-form @submit.prevent="updateProfile(true)" @reset="onReset">
        <p class="mt-3">The fields below are required by Shipsurance in order to streamline your claim submissions.</p>

        <b-form-input id="company" class="mb-2" type="text" size="sm" v-model="form.company"
          placeholder="Company Name (please fill if applicable)"></b-form-input>

        <b-form-input id="name" class="mb-2" type="text" size="sm" v-model="form.name" placeholder="Full Name">
        </b-form-input>

        <GoogleAutoComplete :g-class="['form-control', 'form-control-sm', 'mb-2']" v-model="form.address"
          placeholder="Address" @change="onGoogleAddressChange"></GoogleAutoComplete>

        <b-form-input id="address2" class="mb-2" type="text" size="sm" v-model="form.address2"
          placeholder="Address 2 (FL, Apt, Suite, Unit)"></b-form-input>

        <b-form-input id="name" class="mb-2" type="text" size="sm" v-model="form.city" placeholder="City">
        </b-form-input>

        <b-row no-gutters>
          <b-col sm="6">
            <b-form-select class="mb-2" type="text" size="sm" v-model="form.state" placeholder="State"
              :options="stateSelectOptions"></b-form-select>
          </b-col>
          <b-col sm="6">
            <b-form-input class="mb-2" type="text" size="sm" v-model="form.postal_code" placeholder="Postal Code">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col sm="6">
            <b-form-input id="name" class="mb-2" type="text" size="sm" v-model="form.phone" v-mask="'(###) ###-####'"
              placeholder="(XXX) XXX - XXXX"></b-form-input>
          </b-col>
          <b-col sm="6">
            <b-form-input class="mb-2" type="text" size="sm" v-model="form.ext" placeholder="Ext."></b-form-input>
          </b-col>
        </b-row>

        <b-row class="justify-content-between">
          <b-col sm="auto">
            <b-btn @click="verifyAddress" size="sm" class="btn-light-blue-outline mr-2">
              <img class="verifyImg" src="/images/icons/verify-address-blue.png">
              Verify Address
            </b-btn>
          </b-col>
          <b-col sm="auto">
            <b-btn variant="primary" type="submit" size="sm">Save Changes</b-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <div>
      <OriginModal ref="viewOriginModal"></OriginModal>

      <b-modal v-model="showEdit" :title="this.selectedIntegration ? `${this.selectedIntegration.name} alias` : 'Alias'"
        @hidden="hideModal">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label-for="name-input">
            <b-form-input id="name-input" v-model="nickname" placeholder="Enter a nickname (optional)"></b-form-input>
          </b-form-group>
        </form>

        <div slot="modal-footer">
          <div class="text-right">
            <b-btn class="btn-blue" @click="saveForm">Save and Close</b-btn>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#integration-table {
  tbody {
    tr {
      td {
        vertical-align: middle;
        text-align: center;
        ;
      }
    }
  }
}

a.nav-link {
  font-size: 0.75rem !important;
}

.subscription-table {
  border-collapse: separate;
  border-spacing: 50px 0;

  .sup {
    font-size: .425em;
    line-height: 1.8;
  }

  thead {
    .best {
      position: absolute;
      top: 0;
      left: auto;
      right: 0;
      transform: rotate(90deg);
      width: 150px;
      overflow: hidden;
      height: 150px;

      span {
        display: block;
        text-align: center;
        left: 0;
        width: 200%;
        transform: translateY(-50%) translateX(-50%) translateX(35px) rotate(-45deg);
        margin-top: 35px;
        font-size: 13px;
        line-height: 2;
        font-weight: 800;
        text-transform: uppercase;
        background: #000;
      }
    }

    th {
      text-align: center;
      color: #e9ecef;
      padding: .5rem;
      border-bottom: 1px solid white;
      width: 250px;
      border-radius: 25px 25px 0 0;

      h2 {
        font-weight: bold;
        margin-top: .5rem;
      }

      // &.starter, &.supreme {
      //   font-style: italic;
      //   font-weight: bolder;
      // }

      &.plan {
        background-color: #1C244B;
      }

      &.starter {
        background-color: #E4AC2B;
      }

      &.supreme {
        background-color: #226F1D;
        position: relative;
      }
    }

    .desc {
      td {
        text-align: center;
        color: #e9ecef;
        padding: .5rem;

        h6 {
          font-weight: bold;
        }

        &.plan {
          background-color: #1C244B;
        }

        &.starter {
          background-color: #E4AC2B;
        }

        &.supreme {
          background-color: #226F1D;
        }
      }
    }

    .desc-2 {
      td {
        padding: 12px 0;
        text-align: center;
        border: 1px solid #0000001a;

        h3,
        h6 {
          font-weight: bold;
        }
      }
    }
  }

  tbody {
    .default {
      background: none !important;

      td {
        border: 0 !important;
      }

      .btn {
        padding: 0.5rem !important;
        width: 100px;
      }
    }

    tr {

      &:not(.desc),
      &:not(.default) {
        &:nth-child(odd) {
          background-color: #e6e8eb;
        }

        &:nth-child(even) {
          background-color: #f2f4f7;
        }

        td {
          text-align: center;
          padding: .5rem;
          border: 1px solid #0000001a;
          font-weight: bold;
        }
      }
    }
  }
}

.shipsurance-input {
  font-size: 12px;
  padding: 0 8px !important;
  height: 20px;
  margin-top: 3px;
  margin-right: 6px;
}
</style>

<style lang="scss">
.chckbox-grp {
  columns: 4;

  .custom-checkbox {
    min-height: auto;
    margin-bottom: 5px;

    .custom-control-label {

      &::before,
      &::after {
        top: 1px;
      }
    }
  }
}

.originsTable {
  .VuePagination {
    display: none !important;
  }
}

.stripe-card {
  .StripeElement {
    height: 28px !important;
    padding: 2px 12px !important;
  }
}
</style>

<script>
import Alerts from "../../components/Alerts";
import LoadingSpinner from "../../components/LoadingSpinner";
import PostageRefill from "../../components/PostageRefill";
import PostageRefillSettings from "../../components/PostageRefillSettings";
import GoogleAutoComplete from "../../components/GoogleAutoComplete";

//import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from "vue-stripe-elements-plus";

import states from "../../data/states";
import labels from "../../data/labels";
import mailClasses from "../../data/mail-classes";
import formatters from "../../formatters";
import insurance from "../../data/insurance";

import { mapGetters, mapActions } from "vuex";
import validations from './validations'
import Origins from './mixins/Origins'
import AccountInformation from './mixins/AccountInformation'
import Dimensions from './mixins/Dimensions'
import Validation from '../../mixins/Validation'

import OriginModal from './OriginModal';

import marketplaces from "../../data/marketplaces";
import { shippingOptions } from "../../data/shipping-options";

export default {
  mixins: [
    Validation,
    Origins,
    AccountInformation,
    Dimensions,
    GoogleAutoComplete
  ],
  components: {
    OriginModal,
    Alerts,
    LoadingSpinner,
    Card,
    PostageRefill,
    PostageRefillSettings,
    GoogleAutoComplete,
  },
  data() {
    return {
      pm_irrpkg_help: {
        title: `
        `,
        html: true
      },
      // media_pkg_help: {
      //   title: `
      //   <p class="text-left">
      //     Here's what you can send:
      //     <br />
      //     <br />
      //     <ul class="pl-3 mb-0 text-left">
      //       <li>Books (at least 8 pages)</li>
      //       <li>16-millimeter or narrower width films</li>
      //       <li>Printed music and test materials</li>
      //       <li>Video and sound recordings</li>
      //       <li>Playscripts and manuscripts</li>
      //       <li>Printed educational reference charts</li>
      //       <li>Medical loose-leaf pages and binders</li>
      //       <li>Computer-readable media</li>
      //     </ul>
      //     <br />
      //     <em>NOTE: Video games, computer drives, and digital drives do not qualify for Media Mail prices.</em>
      //   </p>`,
      //   html: true
      // },

      selectedMarketplaces: [],
      marketplaceOptions: [],
      selectedShippingOptions: [],
      shippingSelectOptions: [],

      marketplaces: [],
      showIntegration: null,
      integrations: [],
      selectedIntegration: null,
      showEdit: null,
      nickname: '',

      tab: '',
      showSubscriptionCard: false,
      subscriptionPlan: '',
      isLoading: false,
      shipsuranceLoading: false,
      allowTestPrint: true,
      stripeKey: null,
      stripeOptions: {},
      section: 0,

      form: {
        company: null,
        name: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        postal_code: null,
        phone: null,
        ext: null,
      },
      form2: {
        current_password: null,
        new_password: null,
        new_password_confirmation: null
      },
      form3: {
        current_password: null,
        email: null,
        email2: null
      },
      subscription: {
        data: {},
        subscriptions: [],
        subscribed: false,
        stripeFormComplete: false,
        coupon: null
      },
      shipsurance: {
        stripeFormComplete: false,
        amount: 0,
      },
      origins: {
        default: null,
        data: [],
        columns: [
          "is_default",
          "actions",
          "name",
          "company",
          "address",
          "postal",
          "postal_origin"
        ],
        options: {
          headings: {
            is_default: "Default",
            actions: "Actions",
            name: "Name",
            company: "Company",
            postal: "Postal Code",
            postal_origin: "Origin",
          },
          sortable: [],
          filterable: []
        },
        create_form: {
          first_name: null,
          last_name: null,
          company: null,
          address: null,
          city: null,
          state: null,
          postal: null,
          country: null,
          phone: null,
          actions: null
        },
        edit_form: []
      },
      shipping_label_formats: {
        selected: null,
        preview: null,
      },
      // shipping_label_orientations: {
      //   selected: null,
      //   options: [
      //     { value: null, text: "Automatic" },
      //     { value: "portrait", text: "Portrait" },
      //     { value: "landscape", text: "Landscape" },
      //     { value: "reverse-landscape", text: "Reverse Landscape" }
      //   ]
      // },
      // shipping_label_margins: {
      //   top: 0,
      //   right: 0,
      //   bottom: 0,
      //   left: 0
      // },
      // shipping_label_sizes: {
      //   selected: "A4",
      //   options: labels.getSelectOptions()
      // },
      tmpMyPkg: '0x0x0',
      dimensions: {
        default: null,
        data: [],
        columns: ["is_default", "actions", "name", "length", "width", "height"],
        options: {
          headings: {
            is_default: "Default",
            actions: "Actions",
            name: "Name",
            length: "Length",
            width: "Width",
            height: "Height"
          },
          sortable: [],
          filterable: []
        },
        create_form: {},
        edit_form: []
      },
      active_mail_classes: [],
      selectedService: '',
      selectedPackage: '',
      selectedConfirm: 'Delcon',
      declaredValue: null,
      selectedInsurance: null,
      selectedInsuranceInputs: {},
      weight: { lb: null, oz: null },
      package: { length: null, width: null, height: null },
      weight_set: false,
      dim_set: false,
      dw_set: false,
      noLB: false,

      annually: true,

      subscription_items: [
        // ['INTEGRATION (EBAY/SHOPIFY/ETSY)', 1, 1, 1],
        ['UNLIMITED SHIPMENTS', 1, 1, 1],
        ['ADDRESS BOOK', 1, 1, 1],
        ['USPS COMMERCIAL PLUS RATES', 1, 1, 1],
        ['USPS PRIORITY MAIL CUBIC RATES', 1, 1, 1],
        ['GROUND ADVANTAGE CUBIC RATES', 1, 1, 1],
        ['SCAN-BASED RETURN LABELS', 1, 1, 1],
        ['SUPPORT MULTIPLE ORIGINS', 1, 1, 1],
        ['BATCH PRINT CAPABILITIES', 1, 1, 1],
        ['ABILITY TO PRINT USPS SCAN FORM', 1, 1, 1],
        ['EMAIL SUPPORT', 1, 1, 1],
        ['ADMIN LOCK + CREATE USERS', 0, 1, 1],
        ['PRODUCT CATALOGUE', 0, 1, 1],
        ['EMAIL SHIPMENT NOTIFICATION', 0, 1, 1],
        ['GRAND DONATION', 0, 2, 2],
      ],

      transactions: [],
    };
  },
  validations,
  computed: {
    ...mapGetters({
      user: "getUser",
      balance: "getUserBalance",
      getCarrierRules: "getCarrierRules",
      getSignatureCarrierRules: "getSignatureCarrierRules",
      shippingServices: "getShippingServices",
    }),
    stateSelectOptions() {
      return states.getSelectOptions();
    },
    carrierRules: function () {
      return this.getCarrierRules(this.country || 'US');
    },
    serviceRules() {
      return this.carrierRules[this.selectedService] || [];
    },
    serviceOptions() {
      try {
        let options = Object.keys(this.carrierRules).map(serviceId => {
          return _.find(this.shippingServices, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(options, "order");

        options = options.map(option => {
          if (option) {
            let packageOptions = this.getPackageOptions(option.code);

            // Make sure at least 1 option exists
            if (!packageOptions.length) {
              return null;
            }

            return {
              value: option.code,
              text: option.name
            };
          }
          return null
        });

        return _.filter(options);
      } catch (e) {
        // console.error(e);
        return [];
      }
    },
    packageOptions() {
      if (
        _.isEmpty(this.selectedService) ||
        !this.serviceRules["parcelTypeRules"]
      ) {
        this.selectedPackage = '';
        return [];
      }

      return this.getPackageOptions(this.selectedService);
    },

    signatureOptions() {
      const rules = this.getSignatureCarrierRules(
        this.selectedService,
        this.selectedPackage,
        this.country || 'US',
        false
      );
      // if not
      if (!rules.length) {
        return [{
          value: 'DelCon',
          label: 'Delivery Confirmation (Default Tracking)',
          text: 'Delivery Confirmation (Default Tracking)'
        }];
      }

      let ruleOptions = rules.map(rule => {
        return {
          value: rule.specialServiceId,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
    insuranceOptions() {
      if (_.isEmpty(this.selectedService) || !this.user.shipsurance_terms) {
        return [];
      }

      // Domestic shipment. Just return static options
      // if (this.country === "US") {
      return insurance.getSelectOptions();
      // }

      // International. Use shipping rules
      let rules = this.$store.getters.getInsuranceCarrierRules(
        this.selectedService,
        this.selectedPackage,
        this.country
      );
      const ruleOptions = rules.map(rule => {
        return {
          value: rule,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
    dimensionsPresetOptions() {
      let options = this.dimensions.data
        ? this.dimensions.data.map(dimension => {
          return {
            value: `${dimension.length}x${dimension.width}x${dimension.height}`,
            text: dimension.name
          };
        })
        : [];

      options = _.concat({
        value: '0x0x0',
        text: 'My Custom Packaging',
      }, options);
      return options;
    },
    checkDimensions() {
      const { height, width, length } = this.package;
      console.log("hwl", height, width, length);

      const hasAll = height && width && length;
      if (this.selectedPackage === "SOFTPACK") {
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(height), parseInt(width), parseInt(length)];
        console.log(dim)
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)

        console.log("hasNull", hasNull, "hasVal", hasVal)
        if (hasNull && hasVal) return false
        return true;
      }
    },
    isDimAllowed() {
      if (this.selectedPackage) {
        if (["SOFTPACK", "PKG"].includes(this.selectedPackage)) return false;
        this.package.length = null;
        this.package.height = null;
        this.package.width = null;
        return true;
      }
      return false;
    },
    noWeight() {
      const { oz, lb } = this.weight;
      const isNull = [NaN, 0];
      if (isNull.includes(parseInt(oz)) && isNull.includes(parseInt(lb))) return true;
      return false;
    },
    isPackageDetailInvalid() {
      if (!this.selectedService || !this.selectedPackage || !this.checkDimensions || this.noWeight) return true;
      return false
    }
  },
  created() {
    if (this.$route.params.section) {
    }
    this.fetchInfo();
  },
  async mounted() {
    this.stripeKey = `${process.env.MIX_STRIPE_KEY}`;
    this.tab = this.$route.params.section;
    if (this.user.default_dimension) {
      this.package = {
        width: this.user.default_dimension.width,
        height: this.user.default_dimension.height,
        length: this.user.default_dimension.length
      };
    }
    if (this.user.package_detail_json) {
      const user_package = JSON.parse(this.user.package_detail_json)

      this.selectedService = user_package.selectedService
      this.selectedPackage = user_package.selectedPackage
      this.tmpMyPkg = user_package.tmpMyPkg || '0x0x0'
      this.weight = user_package.weight
      this.package = user_package.package
      this.selectedConfirm = user_package.selectedConfirm
      this.declaredValue = user_package.declaredValue
      this.selectedInsurance = user_package.selectedInsurance || null
    }
    if (this.user.default_package) {
      this.dimensions.default = null;
    }
    if (this.user.subscribed) {
      if (parseInt(this.user.plan_price) === 120) {
        this.annually = true;
      } else {
        this.annually = false;
      }
    }

    if (this.tab == 'shopify') {
      await this.changeTab('integrations')
      // delay
      await new Promise(r => setTimeout(r, 2000))
      $('#shopifyModal').modal()
    }

    this.setShippingOptions();
    this.selectedShippingOptions = this.user.shipping_options;

    // get transaction report
    await this.getTransactionReport()
  },
  watch: {
    signatureOptions: function (val) {
      this.$nextTick(() => {
        this.onChangeSignatureOptions();
      });
    },

    "origins.default"(newVal, oldVal) {
      let vm = this;
      vm.isLoading = true;

      if (newVal) {
        axios
          .post("/origin/" + this.origins.default + "/default")
          .then(response => {
            this.fetchInfo();
            this.refreshUser();
          })
          .finally(() => {
            vm.isLoading = false;
          });
      } else {
        axios
          .post("/origin/default/delete")
          .then(response => {
            this.fetchInfo();
            this.refreshUser();
          })
          .finally(() => {
            vm.isLoading = false;
          });
      }
    },
    "dimensions.default"(newVal, oldVal) {
      let vm = this;
      vm.isLoading = true;

      if (newVal) {
        axios
          .patch("/dimensions/" + this.dimensions.default + "/default")
          .then(response => {
            this.fetchInfo();
            this.refreshUser();
          })
          .finally(() => {
            vm.isLoading = false;
          });
      } else {
        axios
          .post("/dimensions/default/delete")
          .then(response => {
            this.fetchInfo();
            this.refreshUser();
          })
          .finally(() => {
            vm.isLoading = false;
          });
      }
    }
  },
  methods: {
    ...mapActions(["refreshUser", "refreshShipsurance", "addPrintJob"]),

    // updateCard () {
    //   this.complete = this.number && this.expiry && this.cvc

    //   // field completed, find field to focus next
    //   if (this.number) {
    //     if (!this.expiry) {
    //       this.$refs.cardExpiry.focus()
    //     } else if (!this.cvc) {
    //       this.$refs.cardCvc.focus()
    //     }
    //   } else if (this.expiry) {
    //     if (!this.cvc) {
    //       this.$refs.cardCvc.focus()
    //     } else if (!this.number) {
    //       this.$refs.cardNumber.focus()
    //     }
    //   }
    //   // no focus magic for the CVC field as it gets complete with three
    //   // numbers, but can also have four
    // },

    setShippingOptions() {
      this.shippingSelectOptions = shippingOptions.map(v => v)
      console.log("shippingSelectOptions:", this.shippingSelectOptions)
    },
    async getTransactionReport() {
      const { data } = await axios.get('pb/transactions', {
        params: {
          type: 'POSTAGE FUND' // get only postage fund refills
        }
      })

      data.content.forEach(d => {
        this.transactions.push({
          id: d.transactionId,
          date: d.transactionDateTime,
          amount: d.postageDepositAmount
        })
      })

      /* console.log(this.transactions); */
    },

    async onPackageChange() {
      const { lb, oz } = this.weight;
      this.tmpMyPkg = '0x0x0';
      if (lb === null || oz === null) return;
      if (lb === 0 && oz === 0) return;
      if (this.dim_set || this.weight_set) {
        this.dw_set = true;
      }
      if (this.selectedPackage == 'SOFTPACK') {
        this.package.height = 1
      }
    },
    async onPackagingSelected(val) {
      if (!val) return;
      const [l, w, h] = val.split('x');
      this.package = { length: parseInt(l), width: parseInt(w), height: parseInt(h) };
      if (this.selectedPackage == 'SOFTPACK') {
        this.package.height = 1
      }
    },
    async setWeight() {
      // console.log(this.weight.oz, this.weight.lb);
      if ([0, NaN].includes(parseInt(this.weight.oz)) && [0, NaN].includes(parseInt(this.weight.lb))) {
        return;
      } else if ([0, NaN].includes(parseInt(this.weight.oz)) && ![0, NaN].includes(parseInt(this.weight.lb))) {
        this.weight.oz = 0;
      }

      if (this.weight.oz % 16) {
        if (!this.noLB) {
          this.weight.lb =
            Number(~~(this.weight.oz / 16)) + Number(this.weight.lb);
          this.weight.oz = Number(this.weight.oz % 16);
        } else {
          this.weight.lb = 0;
          this.weight.oz = Number(this.weight.oz % 16);
        }
      }

      if (this.weight_set) {
        console.log("set dw_set to true via weight change")
        this.dw_set = true;
      }
      console.log("dw_set value via weight", this.dw_set);

      this.weight_set = true;
    },
    onServiceClassChange(val) {
      this.selectedService = val;
      this.selectedPackage = 'PKG';

      console.log("service class is: ", val);
      switch (val) {
        case "FCM":
          this.noLB = true;
          this.weight.lb = 0;
          break;
        default:
          this.noLB = false;
      }
      if (this.dim_set || this.weight_set) {
        this.dw_set = true;
      }
      this.tmpMyPkg = '0x0x0';
    },
    getPackageOptions(serviceId) {
      // console.log("SERVICE ID", serviceId);
      let rules = this.$store.getters.getServicePackageRules(
        serviceId,
        this.country || 'US',
        true // filter inactive mail classes
      );

      // Flat Rates, this needs to be updated annually
      const flatRates = {
        EM: {
          FRE: "$24.90",
          LGLFRENV: "$25.15",
          PFRENV: "$25.35"
        },
        PM: {
          FRE: "$7.60", // Flat Rate Envelope
          SFRB: "$8.10", // Small Flat Rate Box
          LFRB: "$18.95", // Large Flat Rate Box
          LGLFRENV: "$7.90", // Legal Flat Rate Envelope
          FRB: "$14.00", // Medium Flat Rate Box
          MLFRB: "$18.35", // APO/FPO/DPO
          PFRENV: "$8.30" // Padded Flat Rate Envelope
        }
      }

      let options = serviceId
        ? rules.map(rule => {
          let name = rule.brandedName;

          if (
            serviceId in flatRates &&
            rule.parcelType in flatRates[serviceId]
          ) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }

          return {
            value: rule.parcelType,
            text: name
          };
        })
        : [];

      return _.orderBy(options, "text");
    },

    async packageDetailToggle(val) {
      const { value } = val;
      try {
        const response = await axios.post('/user-default-package', { package_toggle: value });
        console.log(response);
        this.$emit("alert", {
          message: `Default Package is ${value ? 'enabled' : 'disabled'}!`,
          type: value ? 'success' : 'danger',
        });
        if (value) {
          this.dimensions.default = null;
        }
        this.refreshUser();
      } catch (e) {
        console.log(e);
        this.$emit("alert", {
          message: "Unable to save update!",
          type: "danger"
        });
      }
    },

    async saveDefaultPackage() {
      try {
        const data = {
          'selectedService': this.selectedService,
          'selectedPackage': this.selectedPackage,
          'weight': this.weight,
          'package': this.package,
          'tmpMyPkg': this.tmpMyPkg,
          'selectedConfirm': this.selectedConfirm,
          'declaredValue': this.declaredValue,
          'selectedInsurance': this.selectedInsurance,
        }
        const response = await axios.post('/user-save-default-package', { data: JSON.stringify(data) });
        this.$emit("alert", {
          message: `Default package details saved!`,
          type: 'success',
        });
        this.refreshUser();
      } catch (e) {
        console.log(e);
        this.$emit("alert", {
          message: "Unable to save update!",
          type: "danger"
        });
      }
    },

    onShowOriginModal(id = null) {
      this.$refs.viewOriginModal.onShowModal(id);
    },

    tabHidden(tab) {
      if (!this.user.shipper || !_.isArray(this.user.shipper_tabs)) {
        return false;
      }

      return this.user.shipper_tabs.includes(tab);
    },
    async fetchInfo() {
      let vm = this;
      vm.isLoading = true;

      const [marketplaces, integrations] = await Promise.all([
        axios.get("/marketplaces?ajax=true"),
        await this.loadIntegrations(),
      ]);
      this.marketplaces = marketplaces.data;

      // marketplace reference
      const toInclude = ["amazon", "big commerce", "ecwid by lightspeed", "facebook marketplace", "grailed",
        "instagram", "mercari", "opencart", "paypal", "quickbooks by intuit",
        "square", "squarespace", "stripe", "walmart", "whatnot", "wix", "woocommerce", "x-cart"]

      this.marketplaceOptions = _.orderBy(marketplaces.data.map(m => {
        if (toInclude.includes(m.code)) {
          return { text: m.name, value: m.id, }
        }
        return null
      }).filter(v => v), 'text')

      axios.get("/users").then(response => {
        vm.form.company = response.data.company;
        vm.form.name = response.data.name;
        vm.form.address = response.data.address;
        vm.form.address2 = response.data.address2;
        vm.form.city = response.data.city;
        vm.form.state = response.data.state;
        vm.form.postal_code = response.data.postal_code;
        vm.form.phone = response.data.phone;
        vm.form.ext = response.data.ext;

        vm.origins.data = response.data.origins;
        let defaultOrigin = vm.origins.data.find(origin => origin.is_default);
        if (defaultOrigin && defaultOrigin.id) {
          vm.origins.default = defaultOrigin.id;
        }

        vm.dimensions.data = response.data.dimensions;
        vm.dimensions.default = response.data.default_dimension_id;

        vm.shipping_label_formats.selected = response.data.shipping_label_format_id || 1;
        vm.shipping_label_formats.preview = response.data.shipping_label_format_id || 1;

        vm.subscription.subscribed = response.data.subscribed;
        vm.subscription.data = response.data.subscription
          ? response.data.subscription
          : {};
        vm.subscription.subscriptions = response.data.subscriptions;
        vm.subscription.coupon = response.data.coupon;

        if (response.data.subscribed) {
          if (parseInt(response.data.plan_price) === 120) {
            vm.annually = true;
          } else {
            vm.annually = false;
          }
        }

        if (response.data.active_mail_classes) {
          // console.log("response.data.active_mail_classes", response.data.active_mail_classes);
          vm.active_mail_classes = response.data.active_mail_classes.filter(v => {
            // console.log("MAIL CLASSES", v);
            const disContinued = ["PM-RBB", "PM-RBA"];
            return !disContinued.includes(v)
          });
        } else {
          vm.active_mail_classes = _(
            _.concat(
              this.getActiveMailClassOptions(),
              this.getActiveMailClassOptions("CA")
            )
          )
            .map("value")
            .filter(option => {
              return !mailClasses.disabled.default.includes(option);
            })
            .value();
        }

        // add active marketplace options
        if (response.data.marketplaces) {
          vm.selectedMarketplaces = response.data.marketplaces.map(m => m.value)
        }

        vm.isLoading = false;
      });
    },

    onGoogleAddressChange(addr) {
      if (addr.country !== 'US') {
        this.$emit('alert', {
          type: 'danger',
          message: 'Only addresses from US is allowed.'
        })
      } else {
        addr.postal = addr.postal_code
        addr.postal_origin = addr.postal_code
        addr.state = addr.state || addr.province
        this.origins.create_form = Object.assign({}, this.origins.create_form, addr);
      }
    },

    onReset(e) { },

    pay() {
      let vm = this;
      vm.isLoading = true;
      const cardElem = this.$refs.subscription_card.stripeElement;

      createToken(cardElem).then(data => {
        if (!data.token) {
          vm.$emit("alert", {
            message: "Failed to register card",
            type: "danger"
          });
          vm.isLoading = false;
          return;
        }

        axios
          .post("/users/subscribe", {
            token: data.token,
            coupon: this.subscription.coupon,
            annually: this.annually,
          })
          .then(response => {
            vm.$emit("alert", {
              message: response.data.message,
              type: "success"
            });
          })
          .catch(error => {
            vm.$emit("alert", {
              message: error.response.data.message,
              type: "danger"
            });
          })
          .finally(() => {
            vm.isLoading = false;
            vm.subscriptionPlan = ''
            this.fetchInfo();
            this.refreshUser();
          });
      });
    },
    async unsubscribe(e) {
      let dialog = null;
      try {
        const msg = `Your request to cancel the Supreme subscription has been approved. &nbsp;No further charges will occur.`;
        dialog = await this.$dialog.confirm(msg);

        if (dialog) {
          this.isLoading = true;
          if(!this.user.shopify_id) {
            axios
              .post("/users/unsubscribe", {})
              .then(response => {
                this.$emit("alert", {
                  message: response.data.message,
                  type: "success"
                });
              })
              .catch(error => {
                this.$emit("alert", {
                  message: error.response.data.message,
                  type: "danger"
                });
              })
              .finally(() => {
                this.isLoading = false;
                this.subscriptionPlan = ''
                this.fetchInfo();
                this.refreshUser();
              });
            }else{
              console.log("SHOPIFY BILLING API (UNSUBSCRIBE)!!!");
              try{
                const {data: { message, status }} = await axios.get("/integrate/shopify/billing/cancel");
                /* console.log("DATA: ", data); */ 
                if(!status) throw new Error("Unable to connect with Shopify!");
                this.$emit("alert", {
                  message,
                  type: "success"
                });
                this.isLoading = false;
                this.subscriptionPlan = ''
                this.fetchInfo();
                this.refreshUser();
              }catch(e){
                this.$emit("alert", {
                  message: e.message,
                  type:"danger"
                });
                this.isLoading = false;
              }
            }
        }
      } catch (e) {
        console.log('cancel subscription error', e);
      } finally {
        if (dialog) dialog.close();
        this.isLoading = false;
      }
    },
    updateCard() {
      let vm = this;
      vm.isLoading = true;
      const cardElem = this.$refs.subscription_card.stripeElement;

      createToken(cardElem).then(data => {
        if (!data.token) {
          vm.$emit("alert", {
            message: "Failed to register card",
            type: "danger"
          });
          vm.isLoading = false;
          return;
        }

        axios
          .patch("/users/card", { token: data.token })
          .then(response => {
            vm.$emit("alert", {
              message: response.data.message,
              type: "success"
            });
          })
          .catch(error => {
            vm.$emit("alert", {
              message: error.response.data.message,
              type: "danger"
            });
          })
          .finally(() => {
            vm.isLoading = false;
            this.fetchInfo();
            this.refreshUser();
          });
      });
    },

    getOriginById(originId) {
      const origin = this.origins.data.find(o => o.id === originId);
      return origin || null;
    },

    async updatePrintSettings(id) {
      try {
        console.log('update print settings: ', id);
        // this.shipping_label_formats.selected = id;
        this.shipping_label_formats.preview = id;
        this.allowTestPrint = false;
        this.isLoading = true;
        const data = {
          shipping_label_format_id: id,
        };
        const response = await axios.patch("/users/" + this.user.id, data);
        this.$emit("alert", {
          message: "Paper setting updated!",
          type: "success"
        });
      } catch (e) {
        if (e.response) {
          this.$emit("alert", {
            message: e.response.data.message,
            type: "danger"
          });
        } else {
          console.error(e);
        }
      } finally {
        this.isLoading = false;
        await this.refreshUser();
        this.allowTestPrint = true;
      }
    },

    async onClickPrintTest() {
      this.isLoading = true;
      let defaultOrigin = this.origins.data.find(d => {
        return d.is_default;
      })
      if (!defaultOrigin && this.origins.data.length) {
        defaultOrigin = this.origins.data[0];
      }
      if (!defaultOrigin) {
        let dialog = await this.$dialog.alert('There must be a valid Origin Address to perform this action.', {
          okText: 'Close',
        });
        dialog.close()
        this.isLoading = false;
        return
      }

      const printData = {
        fromAddress: {
          addressLines: [
            defaultOrigin.address,
            "",
            ""
          ],
          cityTown: defaultOrigin.city,
          stateProvince: defaultOrigin.state,
          postalCode: defaultOrigin.postal,
          countryCode: defaultOrigin.country,
          company: defaultOrigin.company,
          name: `${defaultOrigin.first_name || ''} ${defaultOrigin.last_name || ''}`
        },
        toAddress: {
          addressLines: [
            "2297  Oak Street",
            "",
            ""
          ],
          cityTown: 'Old Forge',
          stateProvince: 'NY',
          postalCode: '13420',
          countryCode: 'US',
          company: 'Grandshipper',
          name: `Test Label`
        },
        parcel: {
          weight: {
            "weight": 1,
            unitOfMeasurement: "OZ"
          },
          valueOfGoods: null,
          currencyCode: "USD"
        },
        rates: [
          {
            carrier: "USPS",
            parcelType: "PKG",
            serviceId: "FCM",
            specialServices: [
              {
                specialServiceId: "DelCon",
                inputParameters: []
              }
            ],
            inductionPostalCode: "11214"
          }
        ],
        documents: [
          {
            type: "SHIPPING_LABEL",
            contentType: "URL",
            size: "DOC_4X6",
            fileFormat: "PDF",
            printDialogOption: "EMBED_PRINT_DIALOG"
          }
        ],
        extra: {
          confirmation: "DelCon",
          insurance: null,
          declared_value: null,
          origin_id: defaultOrigin.id,
          tracking_price: 0,
          insurance_price: 0
        },
        isTestPrint: true,
        shipmentOptions: []
      };
      axios.post("/printlabel", printData).then(response => {
        const decoded = response.data;
        this.addPrintJob(decoded);
      })
        .finally(() => {
          this.$emit("alert", {
            message: "Test Label Printed!",
            type: "success"
          });
          this.isLoading = false;
        });
    },

    getActiveMailClassOptions(country = "US") {
      let options = [];

      let services = Object.keys(this.getCarrierRules(country)).map(
        serviceId => {
          return _.find(this.shippingServices, s => {
            return s && s.code === serviceId;
          });
        }
      );

      services = _.orderBy(services, "order");

      // if (country === "US") {
      //   console.log('RULES', this.getCarrierRules(country))
      //   console.log('SS', this.shippingServices)
      //   console.log('SERVICES', services)
      // }

      services.forEach(service => {
        if (!service) return;
        let rules = this.$store.getters.getServicePackageRules(
          service.code,
          country
        );

        rules.forEach(rule => {
          let name = rule.brandedName;
          let code = rule.parcelType;

          options.push({
            value: `${service.code}-${code}`,
            text: `${service.name} - ${name}`
          });
        });
      });
      // faker
      if (country === "US") {
        // options.push({
        //   value: `PM-RBA`,
        //   text: `Priority Mail - Regional Box A`
        // });
        // options.push({
        //   value: `PM-RBB`,
        //   text: `Priority Mail - Regional Box B`
        // });
        // PRCLSEL-SOFTPACK", "PRCLSEL-PKG", "FCM-PKG", "FCM-IRRPKG
        options.push({
          value: `PRCLSEL-PKG`,
          text: `Parcel Select Ground - Package (your box/polybag)`
        });
        options.push({
          value: `PRCLSEL-SOFTPACK`,
          text: `Parcel Select Ground - Cubic Soft Pack`
        });
        options.push({
          value: `FCM-PKG`,
          text: `First Class Package - Package (your box/polybag)`
        });
        options.push({
          value: `FCM-IRRPKG`,
          text: `First Class Package - Irregular Package`
        });
      }

      return options;
    },

    updateActiveMailClasses() {
      let data = {
        active_mail_classes: this.active_mail_classes
      };

      this.isLoading = true;

      axios
        .patch("/users/" + this.user.id, data)
        .then(resp => {
          this.$emit("alert", {
            message: this.$t("alerts.active_mail_classes.updated"),
            type: "success"
          });
        })
        .finally(() => {
          this.fetchInfo();
          this.refreshUser();
          this.isLoading = false;
        });
    },
    async unLinkPB() {
      try {
        const msg = "Are you sure you want to unlink your Pitney Bowes account? &nbsp;You will be logged out and unable to create any shipments."
        const dialog = await this.$dialog.confirm({ title: 'Unlink Pitney Bowes Account', body: msg }, {
          view: 'warning',
          customClass: 'warning-dialog',
          proceed: 'Unlink'
        });
        await axios.delete('pb/disconnect');
        await axios.post("/logout");
        localStorage.clear();
        window.location = "/";
      } catch (e) {
        console.error('Unable to unlink PB Account', e);
      }
    },

    /*
    setDefaultDimension(dimensionId) {
      axios.patch('dimensions/default/' +  dimensionId)
      .then(response => {

      })
      .catch(error => {
            vm.$emit('alert', {
              message: error.response.data.message,
              type: 'danger'
            });
          })
          .finally(() => {
            vm.fetchInfo();
            vm.refreshUser();
          });
    },*/

    async changeTab(val) {
      this.tab = '';
      await this.$nextTick();
      this.tab = val;
      if (val == 'integrations') {
        this.showIntegration = true
      } else {
        this.showIntegration = null
      }
    },

    payShipsurance() {
      let vm = this;
      vm.shipsuranceLoading = true;

      axios
        .post("/users/charge", { amount: this.shipsurance.amount })
        .then(response => {
          console.log(response);
          vm.$emit("alert", {
            message: response.data.message,
            type: response.data.status === "error" ? "danger" : "success"
          });
        })
        .catch(error => {
          vm.$emit("alert", {
            message: error.response.data.message,
            type: "danger"
          });
        })
        .finally(() => {
          vm.shipsuranceLoading = false;
          vm.shipsurance.amount = 0;
          this.fetchInfo();
          this.refreshUser();
          this.refreshShipsurance();
        });
    },

    updateShipsuranceCard() {
      let vm = this;
      vm.isLoading = true;
      const cardElem = this.$refs.shipsurance_card.stripeElement;

      createToken(cardElem).then(data => {
        if (!data.token) {
          vm.$emit("alert", {
            message: "Failed to register card",
            type: "danger"
          });
          vm.isLoading = false;
          return;
        }

        axios
          .patch("/users/shipsurance-card", { token: data.token })
          .then(response => {
            vm.$emit("alert", {
              message: response.data.message,
              type: "success"
            });
          })
          .catch(error => {
            vm.$emit("alert", {
              message: error.response.data.message,
              type: "danger"
            });
          })
          .finally(() => {
            vm.isLoading = false;
            this.fetchInfo();
            this.refreshUser();
          });
      });
    },

    async shipsuranceToggle(val) {
      const { value } = val;
      try {
        const { data } = await axios.post('/users/shipsurance', { shipsuranceToggle: value });
        if (data.status === 'error') {
          this.$emit("alert", {
            message: data.message,
            type: 'danger',
          });
          this.user.enable_shipsurance = false;
        } else {
          this.$emit("alert", {
            message: `Shipsurance is ${value ? 'enabled' : 'disabled'}!`,
            type: value ? 'success' : 'danger',
          });
        }
        this.refreshUser();
      } catch (e) {
        this.$emit("alert", {
          message: "Unable to save update!",
          type: "danger"
        });
      }
    },

    hideProfileModal() {
      this.user.shipsurance_terms = 0
      this.$refs.profileModal.hide()
    },

    async updateUserShipsurance() {
      this.$refs.profileModal.show()
    },

    async toggleSubscription() {
      if (this.subscription.subscribed) {
        let dialog = null;
        try {
          const msg = `Are you sure you want to change plan?.<br /><br />The next charge will be applied after the end of your subscription.`;
          dialog = await this.$dialog.confirm(msg);
          if (dialog) {
            this.annually = !this.annually;

            // if not shopify user
            if(!this.user.shopify_id) {
              await axios
              .post("/users/change-plan", {
                annually: this.annually,
              })
              .then(response => {
                this.$emit("alert", {
                  message: response.data.message,
                  type: response.data.status
                });
              })
              .catch(error => {
                this.$emit("alert", {
                  message: error.response.data.message,
                  type: "danger"
                });
              })
              .finally(() => {
                this.isLoading = false;
                this.refreshUser();
                this.fetchInfo();
              });
            }else{
              console.log("SHOPIFY BILLING API (UPDATE SUBSCRIPTION)!!!");
              try{
                const {data: { target }} = await axios.get("/integrate/shopify/billing/", {
                  params: {
                    p: this.annually? "a" : "m",
                  }
                });
                /* console.log("DATA: ", data); */ 
                if(!target) throw new Error("Unable to connect with Shopify!");
                window.location = target; 
              }catch(e){
                this.$emit("alert", {
                  message: e.message,
                  type: "danger"
                });
              }
            }

          }
        } catch (e) {
          if (typeof (e) === 'object') {
            let message = e.response.data.message;
            if (e.response.data.errors) {
              message += ": ";
              message += Object.values(e.response.data.errors).join(" ");
            }
            this.$emit("alert", { message: message, type: "danger" });
          }
        } finally {
          if (dialog) dialog.close();
        }
      } else {
        this.annually = !this.annually
      }
    },

    verifyAddress() {
      let address = formatters.address.toPb(this.form);
      this.isLoading = true;
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$emit("alert", {
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.form = Object.assign({}, this.form, address);
          }
        })
        .catch(e => {
          this.isLoading = false;
          this.$emit("alert", {
            message:
              address.countryCode === "US"
                ? "Address is invalid!"
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
        });
    },
    onGoogleAddressChange(form) {
      if (form.country !== 'US') {
        this.$emit('alert', {
          type: 'danger',
          message: 'Only addresses from US is allowed.'
        })
      } else {
        form.postal = form.postal_code
        form.postal_origin = form.postal_code
        form.state = form.state || form.province
        this.form = Object.assign({}, this.form, form);
      }
    },
    async chooseSubPlan(plan) {
      this.subscriptionPlan = plan
      this.annually = true
      if (plan == 'monthly') {
        this.annually = false
      }

      if(this.user.has_shopify){
        const msg = `All Shopify users will be redirected to shopify for your subscription to be processed.`;
        try{
          const dialog = await this.$dialog.confirm(msg);
          console.log("SHOPIFY BILLING API!!!");
          if(dialog){
            try{
              const {data: { target }} = await axios.get("/integrate/shopify/billing/", {
                params: {
                  p: this.annually? "a" : "m",
                }
              });
              /* console.log("DATA: ", data); */ 
              if(!target) throw new Error("Unable to connect with Shopify!");
              window.location = target; 
            }catch(e){
              this.$emit("alert", {
                message: e.message,
                type: "danger"
              });
            }
          }
        }catch(e){
          console.error(e);
          console.log("canceled");
          this.subscriptionPlan = '';
        }
      }else{
        this.showSubscriptionCard = true
      }
    },
    unSub() {
      this.subscriptionPlan = ''
      this.showSubscriptionCard = false
    },
    async editNickname(integration) {
      this.showEdit = true;
      this.selectedIntegration = integration;
      this.nickname = integration.nickname;
    },
    async deleteIntegration(id) {
      const msg = `Please confirm the deletion of integration chosen.`;
      let dialog = null;
      try {
        dialog = await this.$dialog.confirm({ title: 'Delete Integration', body: msg }, {
          view: 'warning',
          customClass: 'warning-dialog',
        });
        if (dialog) {
          const response = await axios.delete("/integrations/" + id);
          console.log('integration deleted', response.data);
          this.loadIntegrations();
        }
      } catch (e) {
        console.log(e);
      } finally {
        dialog.close();
      }
    },
    async disableIntegration(integration) {
      console.log('disable integration called')
      console.log(integration)
      const response = await axios.patch("/integrations/" + integration.id, {
        status: 'toggle'
      });
      console.log('integration updated', response.data);
      this.loadIntegrations();
    },
    async loadIntegrations(e) {
      try {
        const response = await axios.get("/integrations?ajax=true&all=true")
        this.integrations = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async saveForm() {
      const data = {
        nickname: this.nickname
      }
      const response = await axios.patch("/integrations/" + this.selectedIntegration.id, data);
      console.log('integration nickname updated', response.data);
      await this.loadIntegrations();
      await this.hideModal()
    },
    async hideModal() {
      this.showEdit = false;
      this.selectedIntegration = null;
      this.nickname = '';
    },

    onChangeSignatureOptions() {
      if (_.find(this.signatureOptions, { value: this.selectedConfirm })) {
        return;
      }
      if (
        this.signatureOptions.length === 1 &&
        this.signatureOptions[0].value === null
      ) {
        this.selectedConfirm = null;
      } else if (this.signatureOptions.length > 1) {
        const hasDelCon = _.find(this.signatureOptions, option => {
          return option.value === "DelCon";
        });
        if (hasDelCon) {
          this.selectedConfirm = "DelCon";
        } else if (!_.isNull(this.signatureOptions[0].value)) {
          this.selectedConfirm = this.signatureOptions[0].value;
        } else {
          this.selectedConfirm = this.signatureOptions[1].value;
        }
      } else if (
        this.selectedConfirm === null &&
        this.signatureOptions.length > 0
      ) {
        this.selectedConfirm = this.signatureOptions[0].value;
      } else if (this.signatureOptions.length === 0) {
        this.selectedConfirm = null;
      }
    },
    onKeyUpDeclaredValue(e, rule) {
      clearTimeout(this.getRateTimer);
      let val = e.target.value;
      this.declaredValue = val;
      if (!val) {
        this.selectedInsurance = null;
        this.selectedInsuranceInputs[rule.brandedName] = 0;
        this.getRate();
      } else if (rule && val >= rule.minValue && val <= rule.maxValue) {
        this.getRateTimer = setTimeout(() => {
          this.getRate();
        }, 250);
      }
    },
    async saveSelectedShippingOptions() {
      try {
        const response = await axios.post("/users/shipping-options", { shipping_options: this.selectedShippingOptions });
        console.log('response', response);
        this.$emit("alert", {
          message: response.data.message,
          type: "success"
        });
        await this.refreshUser();
        console.log("shipping options: ", this.user.shipping_options);
      } catch (e) {
        console.error(e);
        this.$emit("alert", {
          message: "Unable to save shipping options",
          type: "danger"
        });
      }
    },

    async saveMarketPlaces() {
      try {
        const currentDefault = this.user.marketplaces ? this.user.marketplaces.find(u => u.is_default) : null

        const mp = this.marketplaceOptions.map(m => {
          if (this.selectedMarketplaces.includes(m.value)) {
            if (currentDefault && currentDefault.value == m.value) {
              return { value: m.value, is_default: 1 }
            }
            return { value: m.value }
          }
          return null
        }).filter(v => v)

        const response = await axios.post("/users/marketplaces", { marketplaces: mp });
        console.log('response', response);
        this.$emit("alert", {
          message: response.data.message,
          type: "success"
        });
      } catch (e) {
        this.$emit("alert", {
          message: e.response.data.message,
          type: "danger"
        });
      } finally {
        await this.refreshUser();
        await this.fetchInfo();
      }
    },
    isDiscontinued(pType) {
      const disContinued = ["PRCLSEL-SOFTPACK", "PRCLSEL-PKG", "FCM-PKG", "FCM-IRRPKG"];
      if (disContinued.includes(pType)) return true;
      return false;
    }

  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/MyAccount/Index.vue